import clsx from 'clsx';
import { TYPE_FILTER_LABEL, TYPE_FILTER_OPTIONS } from '../approvals.definitions';
import type { ApprovalCounts, ApprovalTypeFilter as TypeFilter } from '../approvals.types';

interface ApprovalTypeFilterProps {
    value: TypeFilter;
    counts: ApprovalCounts;
    onChange: (value: TypeFilter) => void;
}

export function ApprovalTypeFilter({ value, counts, onChange }: ApprovalTypeFilterProps) {
    return (
        <div className="flex flex-wrap items-center gap-2" role="group" aria-label={TYPE_FILTER_LABEL}>
            {TYPE_FILTER_OPTIONS.map((option) => {
                const isActive = value === option.value;
                const count = counts[option.value];

                return (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => onChange(option.value)}
                        aria-pressed={isActive}
                        className={clsx(
                            'inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 font-montserrat',
                            isActive
                                ? 'border-primary-300 bg-primary-50 font-semibold text-primary-700'
                                : 'border-primary-100 bg-white font-medium text-raro-gray-600 hover:border-primary-200 hover:text-raro-gray-800'
                        )}
                    >
                        {option.label}
                        <span
                            className={clsx(
                                'inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-[11px] font-semibold',
                                isActive ? 'bg-primary-100 text-primary-700' : 'bg-gray-100 text-raro-gray-500'
                            )}
                        >
                            {count}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
